<dr-flex-home-ui-widget-header [customRightWidget]="true" [title]="'FLEX_HOME.WEATHER_WIDGET.TITLE' | translate">
  <dr-flex-home-ui-accu-weather-logo customRightWidget></dr-flex-home-ui-accu-weather-logo>
</dr-flex-home-ui-widget-header>
<dsy-card class="weather-card" card-color="#fff" height="auto" custom-style="border-radius: 0.62rem; padding:1rem; margin-top: 1.25rem" is-round-border="true">
  @if (store.loading()) {
    <!-- Loading -->
    <!-- TODO - place here Loading component -->
    <div class="loading-spinner">
      <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
    </div>
  } @else if (store.error()) {
    <!-- Error -->
    <!-- TODO - place here Error component -->
    <div class="weather-error-message">
      <p>Error</p>
    </div>
  } @else if (!store.data()?.days?.length) {
    <!-- Empty / No data -->
    <!-- TODO - place here Empty / No data component -->
    <div class="weather-error-message">
      <p>
        {{ 'FLEX_HOME.COMMON.NO_DATA' | translate }}
      </p>
    </div>
  } @else {
    <dr-flex-home-ui-weather-top />
    <dr-flex-home-ui-weather-middle />
    <dr-flex-home-ui-weather-bottom />
  }
</dsy-card>
